import { render } from "./EmployeeDetailsExtView.vue?vue&type=template&id=3118a995&scoped=true"
import script from "./EmployeeDetailsExtView.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsExtView.vue?vue&type=script&lang=js"

import "./EmployeeDetailsExtView.vue?vue&type=style&index=0&id=3118a995&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3118a995"]])

export default __exports__